import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (this.hasDialogTarget) {
      this.dialogElement = this.dialogTarget
      if (this.dialogElement.parentElement !== document.body) {
        this.originalParent = this.dialogElement.parentElement
        document.body.appendChild(this.dialogElement)
        
        this.clickListener = this.handleClickOutside.bind(this)
        this.dialogElement.addEventListener('click', this.clickListener)
      }
    }
  }

  disconnect() {
    if (this.dialogElement && this.clickListener) {
      this.dialogElement.removeEventListener('click', this.clickListener)
    }
    if (this.dialogElement && this.originalParent) {
      this.originalParent.appendChild(this.dialogElement)
    }
  }

  handleClickOutside(e) {
    if (e.target === this.dialogElement || e.target.closest('[data-action="click->modal#close"]')) {
      this.close(e)
    }
  }

  open(e) {
    if (e) e.preventDefault()
    if (this.dialogElement) {
      this.dialogElement.classList.remove("hidden")
      this.dialogElement.classList.add("flex")
      document.body.classList.add("overflow-hidden")
    }
  }

  close(e) {
    if (e) e.preventDefault()
    if (this.dialogElement) {
      this.dialogElement.classList.add("hidden")
      this.dialogElement.classList.remove("flex")
      document.body.classList.remove("overflow-hidden")
    }
  }
}
